import Card from 'components/Card';
import Picture from 'components/Picture';
import React from 'react';
import Line from '../../components/Line';
import { ProductAssociationWithImage } from '../../../server/services/cms/Cms';

interface ProductAssociationsProps {
  products: Array<ProductAssociationWithImage>;
}

type Props = React.FC<React.HTMLProps<HTMLDivElement> & ProductAssociationsProps>;

export const ProductAssociations: Props = ({ className, ...props }) => {
  return (
    <div className="container" {...props}>
      <div className="row">
        <div className="text-h1-display col-span-12 md:col-start-1 md:col-end-5 lg:col-start-2 ">
          <h2>
            You might <br /> also like
          </h2>
          <Line />
        </div>

        {props.products &&
          props.products.slice(0, 2).map((p, i) => (
            <Card
              className={`
                col-span-12 
                xs:col-span-6 
                sm:col-span-5 ${i === 0 ? 'sm:col-start-3' : ''}
                md:col-span-4
                ${i === 0 ? 'mb-16 xs:mb-0' : ''}
              `}
              key={p.name}
              trackerClass="tracker-cta-product-product_associations-211014-121913"
              href={p.ctaTarget}
              title={p.name}
              image={
                <div className="p-4 pb-0">
                  <Picture url={p.imageUrl} alt={p.name} className="xs:aspect-ratio-1by1" />
                </div>
              }
              ctaTitle="View Product"
              children={<p className="mt-4 text-sm lg:my-8">{p.content}</p>}
            />
          ))}
      </div>
    </div>
  );
};
